module.exports = __webpack_public_path__ + "img/sponsor-small.f58b9333.jpg";